<template>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0137 20.7159C15.8339 20.7159 15.6543 20.6473 15.5172 20.5103L11.2057 16.1987C10.9314 15.9245 10.9314 15.4798 11.2057 15.2056C11.4799 14.9315 11.9245 14.9315 12.1987 15.2056L16.0137 19.0207L19.8286 15.2058C20.1029 14.9316 20.5474 14.9316 20.8215 15.2058C21.0959 15.4799 21.0959 15.9246 20.8215 16.1989L16.5101 20.5104C16.373 20.6474 16.1933 20.7159 16.0137 20.7159Z" fill="#EAEBEF"/>
    </svg>
</template>

<script>
export default {
    name: 'ArrowDownIcon'
}
</script>
